import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import './SplashScreen.css';

const SplashScreen = () => {
  const navigate = useNavigate();
  const [phase, setPhase] = useState('init'); // init → logo → tagline → exit

  useEffect(() => {
    // Only show on native mobile
    if (!Capacitor.isNativePlatform()) {
      navigate('/login', { replace: true });
      return;
    }

    const t1 = setTimeout(() => setPhase('logo'), 100);
    const t2 = setTimeout(() => setPhase('tagline'), 1400);
    const t3 = setTimeout(() => setPhase('exit'), 2800);
    const t4 = setTimeout(() => navigate('/login', { replace: true }), 3500);

    return () => [t1, t2, t3, t4].forEach(clearTimeout);
  }, [navigate]);

  return (
    <div className={`splash-root ${phase}`}>

      {/* Ambient background orbs */}
      <div className="splash-orb orb-1" />
      <div className="splash-orb orb-2" />
      <div className="splash-orb orb-3" />

      {/* Flowing wave rings */}
      <div className="splash-rings">
        <div className="ring ring-1" />
        <div className="ring ring-2" />
        <div className="ring ring-3" />
      </div>

      {/* Center content */}
      <div className="splash-center">

        {/* AF monogram */}
        <div className="splash-monogram">
          <div className="monogram-bg" />
          <span className="monogram-text">
            <span className="mono-a">A</span>
            <span className="mono-f">F</span>
          </span>
          <div className="monogram-ring" />
        </div>

        {/* Brand name */}
        <div className="splash-brand">
          <span className="brand-air">Air</span><span className="brand-flyp">Flyp</span>
        </div>

        {/* Tagline */}
        <div className="splash-tagline">
          <span>AI-Powered CRM</span>
        </div>

      </div>

      {/* Bottom subtle line */}
      <div className="splash-bottom-line" />

    </div>
  );
};

export default SplashScreen;